module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notifications"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Notificações"), (_vm.unread_notifications_count > 0) ? _c('span', {
    staticClass: "notifications-count"
  }, [_vm._v(_vm._s(_vm.unread_notifications_count))]) : _vm._e()]), (_vm.notifications_count > 0) ? _c('list', {
    attrs: {
      "notifications": _vm.notifications
    },
    on: {
      "navigate": _vm.close
    }
  }) : _c('div', {
    staticClass: "no-notifications"
  }, [_vm._v("Você ainda não possui nenhuma notificação.")]), (_vm.show_all_notifications_button) ? _c('div', {
    staticClass: "see-all button",
    on: {
      "click": function($event) {
        return _vm.seeAllNotifications()
      }
    }
  }, [_vm._v("ver todas")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52d11766!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/notifications/dropdown.vue
// module id = 1121
// module chunks = 1